$shm_projects_goal_demo $mol_view
	uri \about:blank
	sub /
		<= Open $mol_link
			uri <= uri
			external true
			title \Открыть демо в новой вкладке
			sub / \Интерактивное демо
		<= Frame $mol_embed_native
			uri <= uri
			title \Интерактивное демо
